export const frontmatter = {
    "draft": true,
    "title": "WebChat Integration",
    "description": "Integrate OnnIA WebChat into your website using widgets.",
    "sidebar_label": "WebChat",
    "sidebar_group": "guides",
    "sidebar_order": 2
}

export const toc = []